import React from "react";

import styles from "./ExchangeYear.module.scss";

const ExchangeYear = () => {
  return (
    <a
      className={styles.link}
      href={process.env.REACT_APP_MANAGER_URL}
      target="_blank"
      rel="noreferrer"
    >
      <div className={styles.contents}>
        <p className={styles.title}>重要なお知らせ</p>
        <p className={styles.message}>
          {new Date().getFullYear()}
          年度の授業実施前に年度更新をしてください
        </p>
      </div>
    </a>
  );
};

export default ExchangeYear;
